import { Box, Flex } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { CreditFacilitiesProvider } from '~/contexts/CreditFacilitiesProvider/CreditFacilitiesProvider';
import { CoreGlobalNav } from '~/core/CoreGlobalNav';
import { AppHeader } from '~/packages/common-frontend/layout/Header';
import { CreditFacilityProvider } from '~/packages/credit-facility/hooks/CreditFacilityProvider';

import 'borrower/borrower.scss';

type Props = { children: React.ReactNode };
export const BorrowerTemplate = ({ children }: Props) => {
  const location = useLocation();
  const noPaddingRoutePrefixes = [
    '/deliverables',
    '/settings/credit-facilities',
    '/data-pipeline',
  ];

  const doNotUsePaddingForRoute = _.some(
    noPaddingRoutePrefixes,
    (noPaddingRoutePrefix) =>
      location.pathname.startsWith(noPaddingRoutePrefix),
  );

  return (
    <>
      <AppHeader />
      <Flex grow={1} pt="84px">
        <CoreGlobalNav />
        <Box
          p={doNotUsePaddingForRoute ? undefined : '40px'}
          width="100%"
          overflowX="auto"
        >
          {/* !TODO @eldarshamukhamedov Will I ever get time to clean up this provider mess? Only time will tell =( */}
          <CreditFacilitiesProvider>
            <CreditFacilityProvider>{children}</CreditFacilityProvider>
          </CreditFacilitiesProvider>
        </Box>
      </Flex>
    </>
  );
};
